import React from 'react';
import EditableLabel from '../forms/EditableLabel';
import constants from '../../constants';
import Trash from '../svg/Trash';
import CaptionTooltip from '../common/CaptionTooltip';

export default class SortablePageSectionItemHeader extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            inputEditState: false,
            item: props.item,
            index: props.index,
            changing: props.changing,
        };
        this.updateSectionFromEvent = this.updateSectionFromEvent.bind(this);
        this.sectionTitleChanged = this.sectionTitleChanged.bind(this);
        this.switchState = this.switchState.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (this.props.item !== prevProps.item && this.state.changing) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({ item: this.props.item, changing: false });
        }
    }

    updateSectionFromEvent(e) {
        this.setState((prevState) => { return { ...prevState, item: { ...prevState.item, ignoreTitle: !e.target.checked } }; });
        this.props.onSingleItemChange({ ...this.state.item, ignoreTitle: !e.target.checked });
    }

    sectionTitleChanged(e) {
        this.setState((prevState) => { return { ...prevState, item: { ...prevState.item, name: e.target.value } }; });
        this.props.onSingleItemChange({ ...this.state.item, name: e.target.value });
    }

    switchState() {
        this.setState((prevState) => { return { ...prevState, inputEditState: !prevState.inputEditState }; });
    }

    render() {
        return (
            <div className="card-header">
                {/* eslint-disable-next-line no-nested-ternary */}
                <div className={this.state.item.ignoreTitle ? 'edit-inactive ignored' : this.state?.inputEditState ? 'edit-active' : 'edit-inactive'}>
                    <EditableLabel
                        id={this.state.item.id}
                        placeholder={this.state.item.name}
                        switchState={this.switchState}
                        onChange={this.sectionTitleChanged}
                        value={this.state.item.name}
                        disabled={this.state.item.ignoreTitle}
                        maxChars={255}
                    />
                </div>
                <div className="check-rec">
                    <label data-qa="hide-title-label" id="hide-title__label">
                        <input
                            data-qa="hide-title-checkbox"
                            id="hide-title"
                            name="hide-title"
                            defaultChecked={!this.state.item.ignoreTitle}
                            onChange={this.updateSectionFromEvent}
                            type="checkbox"
                        />
                        <span className={this.state.item.ignoreTitle ? 'checkbox-rec checked' : 'checkbox-rec empty'} />
                        <span className="no-title">
                            No Title
                        </span>
                    </label>
                </div>
                {this.props.sectionCount > 1 && typeof (this.state.item?.contents?.find((c) => { return constants.ContentType.find((ci) => { return c.contentType === ci.Id; }).Type === 'module'; })) === 'undefined'
                && (
                    <CaptionTooltip tooltipText="Delete">
                        <button
                            aria-label="Delete"
                            className="section-delete"
                            type="button"
                            onClick={() => { return this.props.deleteContentSection(this.state.item.id); }}
                        >
                            <Trash />
                        </button>
                    </CaptionTooltip>
                )}
            </div>
        );
    }
}
